 <div class="content">
  <div *ngIf="loading" class="loading">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="101">
    </mat-progress-spinner>
  </div>

  <div class="welcome" *ngIf="!isCommunity() && !loading">Welcome, {{getUserName()}}!</div>

  <div class="search-form" *ngIf="!loading">
    <mat-form-field class="search-bar" appearance="outline">
      <button class="search-icon" (click)="search($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
      <input matInput (keyup)="checkSearchValue($event)"  (keydown.enter)="search($event)" placeholder="Search for patients" (input)="searchField = $event.target.value" [value]="searchField">
      <span matSuffix > </span>
    </mat-form-field>
  </div>  
  <div class="mid-control-bar"  *ngIf="!loading">
      <div class="filter-bar-label">or use filters to find patients</div>
      <!-- <mat-slide-toggle *ngIf="userTeams && userTeams.length > 0" class="teams-toggle"
      color="primary"
      [checked]="showTeamOnly"
      matTooltip="Turn off to see all patients."
      (change)="getPageOfPatients()"
      (toggleChange)="showTeamOnly = !showTeamOnly"
    >
      Show just my team
    </mat-slide-toggle> -->
  </div>
  <div class="filter-bar"  *ngIf="!loading">
    <div *ngFor = "let filter of filters" class="filter-container">
      <patient-list-filter 
        [filter]="filter" 
        [numFilters]="filters.length"
        (editingDone)="onFilterEdit()"
        (removeFilter)="onRemoveFilter($event)">
      </patient-list-filter>
    </div>
    <button class="add-filter" *ngIf="filters.length < 3" (click)="addFilter()" mat-button>+ Add filter</button>
  </div>

 
  <div class="patient-list"  *ngIf="!loading">
    <div class="patient-list-header">
      <div class="header-title" *ngIf="!isCommunity()">Patients</div>
      <form id="displayColumnsFm" [formGroup]="displayColumnsForm">
      <mat-form-field>
        <mat-select  
          [formControlName]="'selectedColumns'" 
          [(value)]="selectedColumns"
           placeholder="Displayed Columns" multiple
        >
          <mat-option *ngFor="let column of displayedColumns" [value]="column.name"  >
            {{column.displayName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
      <mat-paginator [pageSizeOptions]="[10, 25, 50]"
          showFirstLastButtons 
          aria-label="Select page of patients"
          (page)="pagePatientList($event)"
          [length]="getNumberOfPatients()"
          [pageIndex]="getPageNumber()"
          >
      </mat-paginator>
    </div>
  
    <table class="patient-table" mat-table [dataSource]="patients" matSort (matSortChange)="changeSort($event)">
      <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Identifier </th>
        <td  mat-cell (click)="onClickPatient(patient, 'identifier')" *matCellDef="let patient"> {{cleanupIdentifier(patient)}} </td>
      </ng-container>
      <ng-container matColumnDef="friendlyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell  (click)="onClickPatient(patient, 'name')" *matCellDef="let patient"> {{getPatientName(patient)}} </td>
      </ng-container>
      <ng-container *ngIf="isMultiProvider()" matColumnDef="providerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Provider </th>
        <td mat-cell  (click)="onClickPatient(patient, 'name')" *matCellDef="let patient"> {{getProviderName(patient)}} </td>
      </ng-container>
      <ng-container matColumnDef="conditions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Conditions </th>
        <td mat-cell (click)="onClickPatient(patient, 'conditions')" *matCellDef="let patient"> {{patient.conditions.join(', ')}} </td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
        <td mat-cell (click)="onClickPatient(patient, 'address')" *matCellDef="let patient"> {{patient.address}} </td>
      </ng-container>
      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Phone </th>
        <td mat-cell (click)="onClickPatient(patient, 'phone')" *matCellDef="let patient"> {{patient.phone}} </td>
      </ng-container>
      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tags </th>
        <td mat-cell (click)="onClickPatient(patient, 'tags')" *matCellDef="let patient"> {{patient.tags}} </td>
      </ng-container>
      <ng-container matColumnDef="familyIdentifiers">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Family Identifiers </th>
        <td mat-cell  *matCellDef="let patient">
          <u (click)="onClickFamilyIdentifier(patient,identifier)" *ngFor="let identifier of getFamilyIdentifiers(patient)">{{cleanupFamilyIdentifier(identifier)}},</u>
        </td>
      </ng-container>
      <ng-container matColumnDef="teams">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Teams </th>
        <td mat-cell (click)="onClickPatient(patient, 'teams')" *matCellDef="let patient"> {{patient.teams}} </td>
      </ng-container>
      <ng-container matColumnDef="compasses">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Compasses </th>
        <td mat-cell  (click)="onClickPatient(patient, 'compasses')" *matCellDef="let patient"> {{patient.compassNames.join(', ')}} </td>
      </ng-container>
      <ng-container matColumnDef="lastAssignedDt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Assigned Date</th>
        <td mat-cell  (click)="onClickPatient(patient, 'assigned')" *matCellDef="let patient"> {{formatDateNoTZAdjustment(patient.lastAssignedDt)}} </td>
      </ng-container>
      <ng-container matColumnDef="lastMeasurement">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Logged </th>
        <td mat-cell  (click)="onClickPatient(patient, 'logged')" *matCellDef="let patient"> {{formatDate(patient.lastMeasurement)}} </td>
      </ng-container>
      <ng-container matColumnDef="lastAssessmentDt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Assessment Date </th>
        <td mat-cell  (click)="onClickPatient(patient, 'assessed')" *matCellDef="let patient"> {{formatDate(patient.lastAssessmentDt)}} </td>
      </ng-container>
      <ng-container matColumnDef="alerts">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Alerts </th>
        <td mat-cell  (click)="onClickPatient(patient, 'alerts')" *matCellDef="let patient">
           <div *ngFor="let alert of patient.patientAlerts" >
            <mat-icon matTooltip="{{getAlertTooltip(alert)}}" svgIcon="{{getAlertIcon(alert)}}"></mat-icon>
            <!-- <img [ngClass]="{'patient-alert red': alert.icon === 'RED'}" matTooltip="{{getAlertTooltip(alert)}}" src="{{getAlertIcon(alert)}}"/> -->
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="selectedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: selectedColumns;"></tr>
    </table>
    <div class="add-new-container">
      <button mat-fab color="primary" (click)="addPatient()">
     + Add new
      </button>
    </div>
  </div>

</div>
